import Pqp from "../../3x1010/Pqp.js";
import TileMap from "../screen/tilemap/TileMap.js";
import Sheet from "./Sheet.js";
export default class SpriteSheetSlicer {
	constructor(callback) {
		this.sheets = null;
		this.callback = callback;
		SpriteSheetSlicer.that = this;
		this.chosen = new Object();
	}

	init(sheets) {
		this.sheets = sheets;
		this.index = 0;
		this.loadNextSheet();
		this.complexAssets = new Array();
	}

	loadNextSheet() {
		if (this.index < this.sheets.length) {
			this.loadSheet(this.sheets[this.index]);
		} else {
			this.allSheetsLoaded();
		}
	}
	allSheetsLoaded() {

		this.currentSheet = 0;
		//this.tmpD = new Date().getTime();
		this.initNextSheet();
		/*for (let x = 0; x < this.sheets.length; x++) {
			let sheet = new Sheet(this.sheets[x]);
			sheet.init();
			this.sheets[x] = sheet;
		}
		if (this.callback) {
			this.callback.call(null);
		}*/

	}
	initNextSheet() {
		if (this.currentSheet < this.sheets.length) {
			let sheet = new Sheet(this.sheets[this.currentSheet]);
			sheet.init();
			this.sheets[this.currentSheet] = sheet;
			this.currentSheet++;

			let time = 25;
			if (navigator.userAgent.indexOf("Firefox") >= 0) {
				time = 200;
			}
			setTimeout(this.initNextSheet.bind(this), time);
		} else {
			//console.log(new Date().getTime() - this.tmpD)
			if (this.callback) {
				this.callback.call(null);
			}
		}

	}



	loadSheet(sheet) {
		let img = new Image();
		img.onload = this.imageLoaded.bind(this);
		img.src = sheet.file;
		sheet.image = img;
	}

	imageLoaded(e) {
		this.index++;
		this.loadNextSheet();
	}

	getSprite(id, row, col) {

		let styledId = id;
		if (TileMap.STYLER) {
			styledId = TileMap.STYLER.getStyledId(id)
		}
		let sheet = this.sheets[0];
		let a = this.sheets;
		for (let x = 0; x < a.length; x++) {
			if (a[x].sheet.id === styledId) {
				sheet = a[x];
				break;
			}
		}
		return sheet.sprites[row][col];
	}

	getSpriteSheet(id) {
		let styledId = TileMap.STYLER.getStyledId(id)
		let sheet = this.sheets[0];
		let a = this.sheets;
		for (let x = 0; x < a.length; x++) {
			if (a[x].sheet.id === styledId) {
				sheet = a[x];
				break;
			}
		}
		return sheet;
	}

	addComplexAssets(a) {
		this.complexAssets = a.slice();
	}

	getComplexAsset(id) {
		let ret = null;
		for (let x = 0; x < this.complexAssets.length; x++) {
			if (this.complexAssets[x].id === id) {
				return this.complexAssets[x];
			}
		}
		return ret;
	}


	getFurniture(id, parm) {
		if (id === "flour") {
			return this.getFlour(id);
		} else if (id === "shelf") {
			return this.getShelf(id, parm);
		} else if (id === "clock") {
			return this.getClock(id, parm);
		} else if (id === "sack") {
			return this.getSack(id, parm);
		} else if (id === "barrel") {
			return this.getBarrel(id, parm);
		} else if (id === "mannequin") {
			return this.getMannequin(id, parm);
		} else if (id === "forge") {
			return this.getForge(id, parm);
		} else if (id === "bed") {
			return this.getBed(id, parm);
		} else if (id === "weaponholder") {
			return this.getWeaponHolder(id, parm);
		} else if (id === "crate") {
			return this.getCrate(id, parm);
		} else if (id === "smalltable") {
			return this.getSmallTable(id, parm);
		} else if (id === "bucket") {
			return this.getBucket(id, parm);
		} else if (id === "pot") {
			return this.getPot(id, parm);
		} else if (id === "lumber") {
			return this.getLumber(id, parm);
		} else if (id === "potplant") {
			return this.getPotPlant(id, parm);
		} else if (id === "bellows") {
			return this.getBellows(id, parm);
		} else if (id === "anvil") {
			return this.getAnvil(id, parm);
		} else if (id === "throne") {
			return this.getThrone(id, parm);
		} else if (id === "well") {
			return this.getWell(id, parm);
		} else if (id === "library") {
			return this.getLibrary(id, parm);
		} else if (id === "wardrobe") {
			return this.getWardrobe(id, parm);
		} else if (id === "nightstand") {
			return this.getNightstand(id, parm);
		} else if (id === "tableflower") {
			return this.getTableFlower(id, parm);
		} else if (id === "frameflower") {
			return this.getFrameFlower(id, parm);
		} else if (id === "log") {
			return this.getLog(id, parm);
		} else if (id === "chains") {
			return this.getChains(id, parm);
		} else if (id === "workbench") {
			return this.getWorkbench(id, parm);
		}
		return null
	}


	getFlour(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 0, 0));
		return ret;
	}
	getSack(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 0, 1));
		return ret;
	}
	getClock(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 4, 19));
		ret.push(this.getSprite("furniture", 3, 19));
		return ret;
	}


	getShelf(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 5);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 1, 12));
			ret.push(this.getSprite("furniture", 1, 13));
			ret.push(this.getSprite("furniture", 0, 12));
			ret.push(this.getSprite("furniture", 0, 13));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 1, 14));
			ret.push(this.getSprite("furniture", 1, 15));
			ret.push(this.getSprite("furniture", 0, 14));
			ret.push(this.getSprite("furniture", 0, 15));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 1, 16));
			ret.push(this.getSprite("furniture", 1, 17));
			ret.push(this.getSprite("furniture", 0, 16));
			ret.push(this.getSprite("furniture", 0, 17));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 1, 18));
			ret.push(this.getSprite("furniture", 1, 19));
			ret.push(this.getSprite("furniture", 0, 18));
			ret.push(this.getSprite("furniture", 0, 19));
		} else if (n === 4) {
			ret.push(this.getSprite("furniture", 6, 9));
			ret.push(this.getSprite("furniture", 6, 10));
			ret.push(this.getSprite("furniture", 5, 9));
			ret.push(this.getSprite("furniture", 5, 10));
		} else if (n === 5) {
			ret.push(this.getSprite("furniture", 1, 10));
			ret.push(this.getSprite("furniture", 1, 11));
			ret.push(this.getSprite("furniture", 0, 10));
			ret.push(this.getSprite("furniture", 0, 11));
		}
		return ret;
	}

	getBarrel(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 3, 0));
			ret.push(this.getSprite("furniture", 2, 0));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 4, 0));
			ret.push(this.getSprite("furniture", 2, 0));

		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 3, 1));
			ret.push(this.getSprite("furniture", 2, 1));

		}

		return ret;
	}

	getMannequin(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 3);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 6, 3));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 6, 4));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 5, 3));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 5, 4));

		}

		return ret;
	}

	getForge(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 2);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 8, 8));
			ret.push(this.getSprite("furniture", 8, 9));
			ret.push(this.getSprite("furniture", 7, 8));
			ret.push(this.getSprite("furniture", 7, 9));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 8, 10));
			ret.push(this.getSprite("furniture", 8, 11));
			ret.push(this.getSprite("furniture", 7, 10));
			ret.push(this.getSprite("furniture", 7, 11));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 8, 12));
			ret.push(this.getSprite("furniture", 8, 13));
			ret.push(this.getSprite("furniture", 7, 12));
			ret.push(this.getSprite("furniture", 7, 13));
		}
		return ret;
	}


	getBed(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 8, 19));
			ret.push(this.getSprite("furniture", 7, 19));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 8, 16));
			ret.push(this.getSprite("furniture", 7, 16));

		}

		return ret;
	}

	getWeaponHolder(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 8, 3));
			ret.push(this.getSprite("furniture", 8, 4));
			ret.push(this.getSprite("furniture", 7, 3));
			ret.push(this.getSprite("furniture", 7, 4));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 8, 5));
			ret.push(this.getSprite("furniture", 8, 6));
			ret.push(this.getSprite("furniture", 7, 5));
			ret.push(this.getSprite("furniture", 7, 6));
		}
		return ret;
	}

	getCrate(id, n = -1) {

		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 3, 2));
			ret.push(this.getSprite("furniture", 2, 2));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 12, 15));
			ret.push(this.getSprite("furniture", 11, 15));
		}
		return ret;
	}

	getSmallTable(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 4);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 1, 2));
			ret.push(this.getSprite("furniture", 0, 2));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 1, 3));
			ret.push(this.getSprite("furniture", 0, 3));

		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 1, 4));
			ret.push(this.getSprite("furniture", 0, 4));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 1, 5));
			ret.push(this.getSprite("furniture", 0, 5));
		} else if (n === 4) {
			ret.push(this.getSprite("furniture", 1, 6));
			ret.push(this.getSprite("furniture", 0, 6));

		}

		return ret;
	}

	getBucket(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 5, 0));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 5, 1));
		}

		return ret;
	}

	getPot(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 2);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 1, 0));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 1, 1));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 6, 11));
		}

		return ret;
	}



	getLumber(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 11, 2));
		return ret;
	}

	getPotPlant(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 2);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);
		if (n === 0) {
			ret.push(this.getSprite("furniture", 6, 12));
			ret.push(this.getSprite("furniture", 5, 12));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 6, 13));
			ret.push(this.getSprite("furniture", 5, 13));

		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 6, 14));
			ret.push(this.getSprite("furniture", 5, 14));
		}

		return ret;
	}

	getBellows(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 8, 7));
		return ret;
	}
	getAnvil(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 7, 7));
		return ret;
	}

	getThrone(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 11, 10));
		ret.push(this.getSprite("furniture", 10, 10));
		return ret;
	}


	getWell(id) {
		let ret = new Array();
		ret.push(this.getSprite("furniture", 11, 3));
		ret.push(this.getSprite("furniture", 11, 4));
		ret.push(this.getSprite("furniture", 10, 3));
		ret.push(this.getSprite("furniture", 10, 4));
		return ret;
	}

	getLibrary(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 3);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 4, 14));
			ret.push(this.getSprite("furniture", 3, 14));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 4, 15));
			ret.push(this.getSprite("furniture", 3, 15));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 4, 16));
			ret.push(this.getSprite("furniture", 3, 16));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 4, 17));
			ret.push(this.getSprite("furniture", 4, 18));
			ret.push(this.getSprite("furniture", 3, 17));
			ret.push(this.getSprite("furniture", 3, 18));
		}

		return ret;
	}
	getWardrobe(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 4, 12));
			ret.push(this.getSprite("furniture", 3, 12));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 4, 13));
			ret.push(this.getSprite("furniture", 3, 13));
		}

		return ret;
	}

	getNightstand(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 6);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 4, 7));
			ret.push(this.getSprite("furniture", 3, 7));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 4, 8));
			ret.push(this.getSprite("furniture", 3, 8));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 4, 8));
			ret.push(this.getSprite("furniture", 3, 8));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 4, 9));
			ret.push(this.getSprite("furniture", 3, 9));
		} else if (n === 4) {
			ret.push(this.getSprite("furniture", 4, 10));
			ret.push(this.getSprite("furniture", 3, 10));
		} else if (n === 5) {
			ret.push(this.getSprite("furniture", 6, 15));
			ret.push(this.getSprite("furniture", 5, 15));
		} else if (n === 6) {
			ret.push(this.getSprite("furniture", 6, 18));
			ret.push(this.getSprite("furniture", 5, 18));
		}

		return ret;
	}
	getTableFlower(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 2);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 6, 16));
			ret.push(this.getSprite("furniture", 5, 16));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 6, 17));
			ret.push(this.getSprite("furniture", 5, 17));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 6, 19));
			ret.push(this.getSprite("furniture", 5, 19));
		}

		return ret;
	}

	getFrameFlower(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 4);
		} else {
			n = parseInt(n);
		}
		//console.log("----->"+id)
		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 9, 3));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 9, 4));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 9, 5));
		} else if (n === 3) {
			ret.push(this.getSprite("furniture", 9, 6));
		} else if (n === 4) {
			ret.push(this.getSprite("furniture", 9, 7));
		}

		return ret;
	}

	getLog(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 9, 0));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 9, 2));
		}

		return ret;
	}

	getChains(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 1);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 12, 11));
			ret.push(this.getSprite("furniture", 11, 11));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 12, 12));
			ret.push(this.getSprite("furniture", 11, 12));
		}

		return ret;
	}

	getWorkbench(id, n = -1) {
		if (Pqp.isNullOrEmpty(n)) {
			n = -1;
		}
		let ret = new Array();
		if (n === -1) {
			n = this.notChosen(id, 2);
		} else {
			n = parseInt(n);
		}

		this.addtoChosen(id, n);

		if (n === 0) {
			ret.push(this.getSprite("furniture", 14, 16));
			ret.push(this.getSprite("furniture", 14, 17));
			ret.push(this.getSprite("furniture", 13, 16));
			ret.push(this.getSprite("furniture", 13, 17));
		} else if (n === 1) {
			ret.push(this.getSprite("furniture", 14, 18));
			ret.push(this.getSprite("furniture", 14, 19));
			ret.push(this.getSprite("furniture", 13, 18));
			ret.push(this.getSprite("furniture", 13, 19));
		} else if (n === 2) {
			ret.push(this.getSprite("furniture", 16, 16));
			ret.push(this.getSprite("furniture", 16, 17));
			ret.push(this.getSprite("furniture", 15, 16));
			ret.push(this.getSprite("furniture", 15, 17));
		}
		return ret;
	}


	notChosen(id, n) {
		let ret = 0;
		if (!this.chosen[id]) {
			this.chosen[id] = new Array();
		}
		if (this.chosen[id].length >= n) {
			this.chosen[id] = new Array();
		}

		let lCondExit = false;
		while (!lCondExit) {
			ret = Pqp.rnd(n);
			if (this.chosen[id].indexOf(ret) < 0) {
				lCondExit = true;
			}
		}
		return ret;
	}

	addtoChosen(id, n) {
		if (!this.chosen[id]) {
			this.chosen[id] = new Array();
		}
		this.chosen[id].push(n);
	}

}